import { getErrorResponse } from 'legacy/lut/functions'
import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpCancel, HttpHeaders, Rest } from 'core/classes/http'

import { ISPJBPDataResponse } from '../models/ISPJBPDataResponse'

export interface IApplyMPSTargetsSplit {
  partnerId: string
  fyear: number
  fromFYear: number
  programType: string
  isRegionalDistributor: boolean
  cancelObject?: HttpCancel
}

export const applyMPSTargetsSplit = async <T>({
  partnerId,
  fyear,
  fromFYear,
  programType,
  isRegionalDistributor,
  cancelObject,
}: IApplyMPSTargetsSplit): Promise<ISPJBPDataResponse<T>> => {
  let response

  const url = proxy('/webservice/621/sp/v4/spJBPMPSTargetsSplitApply/call')

  const payload = {
    'p.PartnerId': partnerId,
    'p.FYear': fyear,
    'p.FYearFrom': fromFYear,
    'p.ProgramTypes': programType,
    'p.isRegionalDistributor': isRegionalDistributor ? 1 : undefined,
  }

  const { app } = appGetState()
  const [accessToken] = getTokens(app.ownerId)

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    response = await Rest.post({ url, payload, cancelObject, headers })
  } catch (e: any) {
    const errorMessage = 'Failed to request spJBPMPSTargetsSplitApply.'
    response = getErrorResponse<ISPJBPDataResponse<T>>(e.message || errorMessage, {
      Total: -1,
      Data: [],
    })
  }

  return response
}
